import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {PolicyService} from '../../../../../policy/services/policy.service';
import {PolicyStore} from '../../../../../policy/state/policy.store';
import {DatePipe} from '@angular/common';
import {PolicyQuery} from 'src/app/modules/policy/state/policy.query';
import {Router} from '@angular/router';
import {GlobalQuestionService} from 'src/app/modules/shared/services/global-question.service';
import {CalcPremDiffCollation, Collation, Policy, PolicyBenefitsAdded} from '../../../../models/policy.model';
import {EntryType} from '../../../../constants';
import { UserStore } from 'src/app/modules/authentication/state/user.store';

declare var $: any;
declare var accounting: any;

enum Entity {
  Policy = 'Policy',
  Item = 'Item',
  Vap = 'Vap'
}

enum RestoreDateSelection {
  FromDateOfCancellation = 'FromDateOfCancellation',
  EndOfMonth = 'EndOfMonth',
  SpecifiedDate = 'SpecifiedDate'
}

@Component({
    selector: 'app-restore-policy',
    templateUrl: './restore-policy.component.html',
    styleUrls: ['./restore-policy.component.scss'],
    standalone: false
})
export class RestorePolicyComponent implements OnInit, OnChanges {

  @Input() policy: Policy;
  @Input() item: Collation;
  @Input() vap: PolicyBenefitsAdded;
  @Input() entity = '';
  @Input() source = '';
  @Input() new_session_id: any;
  @Input() frequency_id = 3;
  @Input() isEditPolicyPage = false;
  @Output() getNewData = new EventEmitter<boolean>();

  restoreDateSelection = '';
  restoreDate = '';
  restoreDateValue: Date;
  refund: CalcPremDiffCollation;
  accounting: any;
  spinner = false;
  entities = Entity;
  agreeChecked = false;
  restoreButtonEnabled = false;
  restoreDateSelectionEnum = RestoreDateSelection;
  restoreSelectionDateModalButtonEnabled = false;
  restoreMinDate: string;
  restoreMaxDate: string;
  restoreInitialDate = new Date();
  user: any;
  constructor(
    private policyService: PolicyService,
    public datePipe: DatePipe,
    public router: Router,
    private policyQuery: PolicyQuery,
    private userStore: UserStore,
    private questionService: GlobalQuestionService,
    private policyStore: PolicyStore,
    private cdr: ChangeDetectorRef,
    private el: ElementRef) {
      this.user = this.userStore.getValue();
  }

  ngOnInit(): void {
    accounting.settings = {
      currency: {
        symbol: 'R ', // default currency symbol is '$'
        format: '%s%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
        decimal: '.', // decimal point separator
        thousand: ' ', // thousands separator
        precision: 0, // decimal places
      },
      number: {
        precision: 0, // default precision on numbers is 0
        thousand: ' ',
        decimal: '.',
      }
    };
    this.accounting = accounting;
  }

  ngOnChanges(changes: SimpleChanges): void {
    
    if (changes?.policy?.currentValue !== changes?.policy?.previousValue) {
      this.policy = changes?.policy?.currentValue;
    }
    if (changes?.frequency_id?.currentValue !== changes?.frequency_id?.previousValue && changes?.frequency_id?.currentValue != null) {
      this.frequency_id = changes?.frequency_id?.currentValue;
    }
  }

  showRestoreModal(entity: Entity, item?: any): void {
    this.entity = entity;

    if (item) {
      if (entity === Entity.Item) {
        this.item = item;
      } else if (entity === Entity.Vap) {
        this.vap = item;
      }
    }
    else {
      this.entity = Entity.Policy;
    }

    this.getRestoreDateRange();

    this.cdr.detectChanges();
    $(this.el.nativeElement).find('#restore-policy-alert-modal').modal('show');
  }

  getRestoreDateRange(): void {
    let class_id = '0';
    let item_id = '0';
    if (this.entity === Entity.Item) {
      class_id = this.item?.class_id?.toString() ?? '0';
      item_id = this.item?.session_item_id?.toString() ?? '0';
    } else if (this.entity === Entity.Vap) {
      class_id = this.vap?.class_id?.toString() ?? '0';
      item_id = this.vap?.session_item_id?.toString() ?? '0';
    }

    const parameters = new Map<string, string>();
    parameters.set('session_id', this.policy?.session_id?.toString());
    parameters.set('class_id', class_id);
    parameters.set('item_id', item_id);
    this.questionService.runCommandNew('getRestoreDateRange', parameters)
      .subscribe(response => {
        this.restoreMinDate = response?.length ? response[0]?.min_date : null;
        this.restoreMaxDate = response?.length ? response[0]?.max_date : null;
        this.restoreInitialDate = this.restoreMaxDate ? new Date(this.restoreMaxDate) : new Date();
      });
  }

  onDateSelectionChange(): void {
    if (this.restoreDateSelection === RestoreDateSelection.FromDateOfCancellation) {
      this.restoreDate = this.datePipe.transform(new Date(this.policy?.begin_date), 'yyyy-MM-dd');
    } else if (this.restoreDateSelection === RestoreDateSelection.EndOfMonth) {
      const today = new Date();
      this.restoreDate = this.datePipe.transform(new Date(today.getFullYear(), today.getMonth() + 1, 0), 'yyyy-MM-dd');
    }

    if (this.restoreDate) {
      this.restoreSelectionDateModalButtonEnabled = true;
      this.restoreDateValue = new Date(this.restoreDate);
    } else {
      this.restoreSelectionDateModalButtonEnabled = false;
    }
  }

  onDatePickerChange(value: any): void {
    this.restoreDate = value;
    this.restoreDateValue = new Date(this.restoreDate);

    this.restoreSelectionDateModalButtonEnabled = !!this.restoreDate;
  }

  onAgreeChecked(): void {
    this.restoreButtonEnabled = this.agreeChecked;
  }

  populateProperties(): void {
    this.questionService.spinner(true);
    
    switch (this.entity) {
      case Entity.Policy:
         const parameters = new Map<string, string>();
        parameters.set('session_id', this.policy.session_id.toString());
        parameters.set('status_id', '5');
        parameters.set('class_id', '0');
        parameters.set('item_id', '0');
        parameters.set('begin_date', this.restoreDate);
        parameters.set('end_date', this.restoreDate);
        parameters.set('user_updated', this.user?.person_id.toString());
        this.questionService.runCommandNew('savePolicyUpdate', parameters)
          .subscribe(response => {
              this.refund = response.find(item => item.entry_type === EntryType.premium && item.frequency_id === (this.frequency_id ?? 3));
              this.refund.description = this.refund?.description_json ? JSON.parse(this.refund?.description_json) : [];
              $(this.el.nativeElement).find('#restore-policy-alert-modal').modal('hide');
              $(this.el.nativeElement).find('#restore-policy-alert-modal').one('hidden.bs.modal', () => {
                $(this.el.nativeElement).find('#reinstate-summary-modal').modal('show');
              });
              this.questionService.spinner(false);
            },
            err => {
              this.questionService.spinner(false);
            });

        break;
      case Entity.Item:
         parameters.set('session_id', this.policy.session_id.toString());
        parameters.set('status_id', '5');
        parameters.set('class_id', this.item.class_id.toString());
        parameters.set('item_id', this.item.session_item_id.toString());
        parameters.set('begin_date', this.restoreDate);
        parameters.set('end_date', this.restoreDate);
        parameters.set('user_updated', this.user?.person_id.toString());
        this.questionService.runCommandNew('savePolicyUpdate', parameters)
          .subscribe(response => {
              this.refund = response.find(item => item.entry_type === EntryType.premium && item.frequency_id === this.frequency_id);
              this.refund.description = this.refund?.description_json ? JSON.parse(this.refund?.description_json) : [];
              $(this.el.nativeElement).find('#restore-policy-alert-modal').modal('hide');
              $(this.el.nativeElement).find('#restore-policy-alert-modal').one('hidden.bs.modal', () => {
                $(this.el.nativeElement).find('#reinstate-summary-modal').modal('show');
              });
              this.questionService.spinner(false);
            },
            err => {
              this.questionService.spinner(false);
            });
        break;
      case Entity.Vap:
        // console.log(this.item);
        break;

    }
  }

  changeToActive(): void {
    this.questionService.spinner(true);
    if (this.entity === Entity.Policy) {
      this.policyService.submitPolicyUpdates(this.policy?.session_id)
        .subscribe(() => {
          this.questionService.spinner(false);
          $(this.el.nativeElement).find('#reinstate-summary-modal').modal('hide');
          $(this.el.nativeElement).find('#restore-policy-alert-modal').modal('hide');
          this.getNewData.emit(true);
          let documentPageRoute = localStorage.getItem('previous-document-page');
          this.router.navigate([documentPageRoute]);
        }, err => {
          this.questionService.spinner(false);
        });

    } else {
      if (this.isEditPolicyPage) {
        this.getNewData.emit(true);
      } else {
        this.policyService.submitPolicyUpdates(this.policy?.session_id)
          .subscribe(() => {
            this.questionService.spinner(false);
            $(this.el.nativeElement).find('#reinstate-summary-modal').modal('hide');
            $(this.el.nativeElement).find('#restore-policy-alert-modal').modal('hide');
            this.getNewData.emit(true);
          }, err => {
            this.questionService.spinner(false);
          });
      }
    }
  }

  removeAction(status_id: number): void {
    this.questionService.spinner(true);
    if (this.entity === Entity.Policy) {
      this.policyService.removePolicyUpdate(this.policy?.session_id, 0, '0', 0, status_id)
        .subscribe(() => {
          // const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
          // this.policyService.calcPremDiff(this.policy?.session_id, today)
          //   .subscribe(() => {
          //     this.policyService.submitPolicyUpdates(this.policy?.session_id)
          //       .subscribe(() => {
          //         this.questionService.spinner(false);
          //       }, err => {
          //         this.questionService.spinner(false);
          //       });
          //   }, err => {
          //     this.questionService.spinner(false);
          //   });
        }, err => {
          this.questionService.spinner(false);
        });
    } else if (this.entity === Entity.Item) {
      this.policyService.removePolicyUpdate(this.policy?.session_id, this.item?.class_id, this.item?.session_item_id, 0, status_id)
        .subscribe(() => {
          // const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
          // this.policyService.calcPremDiff(this.policy?.session_id, today)
          //   .subscribe(() => {
          //     this.policyService.submitPolicyUpdates(this.policy?.session_id)
          //       .subscribe(() => {
          //         this.questionService.spinner(false);
          //       }, err => {
          //         this.questionService.spinner(false);
          //       });
          //   }, err => {
          //     this.questionService.spinner(false);
          //   });
        }, err => {
          this.questionService.spinner(false);
        });
    } else if (this.entity === Entity.Vap) {
      this.policyService.removePolicyUpdate(this.policy?.session_id, this.vap?.class_id, this.vap?.session_item_id, 0, status_id, this.vap?.vaps_id)
        .subscribe(() => {
          // const today = this.datePipe.transform(new Date(), 'YYYY-MM-dd');
          // this.policyService.calcPremDiff(this.policy?.session_id, today)
          //   .subscribe(() => {
          //     this.policyService.submitPolicyUpdates(this.policy?.session_id)
          //       .subscribe(() => {
          //         this.getNewData.emit(true);
          //         this.questionService.spinner(false);
          //       }, err => {
          //         this.questionService.spinner(false);
          //       });
          //   }, err => {
          //     this.questionService.spinner(false);
          //   });
        }, err => {
          this.questionService.spinner(false);
        });
    }
  }

  closeRestorePolicyAlertModal(): void {
    $(this.el.nativeElement).find('#restore-policy-alert-modal').modal('hide');
  }

  closeReinstateSummaryModal(): void {
    $(this.el.nativeElement).find('#reinstate-summary-modal').modal('hide');
  }

  parseJSON(obj: string): any {
    try {
      return JSON.parse(obj)[0];
    } catch (e) {
      return JSON.parse(obj);
    }

  }
}
